(function ($, w, undefined) {

    function ImageVideoFullWidth(args) {
        this.defaults = {
            container: '.module-image-video-fullwidth',
            playerId: '',
            videoPlayer: null
        };

        this.options = $.extend(true, {}, this.defaults, args);

        var self = this;
        
        THF.Utility.StateManager.addOnEnter('tablet', function () {
            self.destroyPlayer();
        });

        THF.Utility.StateManager.addOnEnter('lrg-desktop', function () {
            self.initPlayer();
            self.bindEvents();
        });
    }
    
    ImageVideoFullWidth.prototype.destroyPlayer = function () {
        if (this.videoPlayer) {
            this.videoPlayer.destroy();
        }
    };

    ImageVideoFullWidth.prototype.parent = function (selector) {
        return $(selector, this.$container);
    };

    ImageVideoFullWidth.prototype.initPlayer = function () {

        this.videoPlayer = new Plyr(this.options.playerId, {
            controls: [],
            settings: [],
            volume: 0,
            muted: true,
            fullscreen: {
                enabled: false
            },
            loop: {
                active: true
            },
            autoplay: true

        });
    };

    ImageVideoFullWidth.prototype.bindEvents = function () {
        // Play video;
        if (typeof this.videoPlayer !== 'undefined' && this.videoPlayer !== false) {
            this.videoPlayer.once('ready', function (e) {
                e.detail.plyr.play();
            });
        }
    };

    w.THF = w.THF || {};
    w.THF.Interface = w.THF.Interface || {};
    w.THF.Interface.ImageVideoFullWidth = ImageVideoFullWidth;
})
(jQuery, window);
